import React, { Component } from 'react';
import './LoadingSpinner.css';

export default class LoadingSpinner extends Component {
  /**
   * @return {React.JSX}
   */
  render() {
    return (
      <div className="cssload-tetrominos">
        <div className="cssload-tetromino cssload-box1"></div>
        <div className="cssload-tetromino cssload-box2"></div>
        <div className="cssload-tetromino cssload-box3"></div>
        <div className="cssload-tetromino cssload-box4"></div>
        <div className="text">... LOADING</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner/LoadingSpinner.js